<template>
  <div id="app">
    <div class="navigation" v-if="flag">
      <navigation-bar></navigation-bar>
      <!-- <navBar></navBar> -->
    </div>
    <div class="routerPage" ref="routerPage">
      <router-view></router-view>
    </div>
    <div class="bottom">
      <information-bar></information-bar>
    </div>

    <changeLanguagePhone v-show="showChange"></changeLanguagePhone>
  </div>
</template>

<script>



import changeLanguagePhone from './components/changeLanguagePhone.vue';
export default {

  name: 'App',
  components: {
    changeLanguagePhone
  },
  data() {
    return {
      flag: true,
      showChange: false
    }
  },
  beforeDestroy(){
    localStorage.removeItem('cueNavName')
  },
  mounted() {
    localStorage.setItem('cueNavName','home')
    if(!localStorage.getItem('change-language')){
      localStorage.setItem('change-language','zh')
    }
    this.$bus.$on('changeFlag', (flag) => {
      if (!flag) {
        this.$refs.routerPage.style.marginTop = '0'
      } else {
        this.$refs.routerPage.style.marginTop = '5rem'
      }
      this.flag = flag
    })
    if(document.body.clientWidth<=992){
      this.showChange = true
    }else{
      this.showChange = false
    }
    const _this = this


this.$nextTick(()=>{
  window.onresize = function () {
      if (document.body.clientWidth <= 992) {
        _this.showChange = true
      } else {
        _this.showChange = false
      }
    }
}
)



  },

}
</script>

<style lang="scss">
* {
  padding: 0;
  margin: 0;
}

#app {
  min-height: 100vh !important;
  display: flex;
  flex-direction: column;
  font-family: 'MyCustomFont';



  .ql-container {
    border: 0px !important;
  }

  .ql-editor {
    padding: 0 !important;
  }


  // background-color: #999;
  .navigation {
    position: fixed;

    top: 0px;
    left: 0;
    width: 100%;
    z-index: 99;

  }

  .routerPage {
    margin-top: 5rem;
    flex: 1;
  }
  

}
</style>
